import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { CustomerAccount } from '@models/customer-account';
import { MobileMasterMenu } from '@models/mobile-master-menu';
import { MobileMenuItem } from '@models/mobile-menu-item';
import { ValidatedUser } from '@models/validated-user';
import { GlobalService } from '@services/global.service';
import { UserService } from '@services/user.service';

import { BaseComponent } from 'src/app/base/base.component';

@Component({
    selector: 'mobile-main-menu',
    templateUrl: './mobile-main-menu.component.html',
    styleUrls: ['./mobile-main-menu.component.less'],
})
export class MobileMainMenuComponent extends BaseComponent implements OnInit {
    mainItemExpansionPanels: QueryList<MatExpansionPanel>;
    masterMenu: MobileMasterMenu;
    languageCode: string;

    @ViewChildren('mainItemExpansionPanels')
    @ViewChild('languagesPanel')

    languagesPanel: MatExpansionPanel;

    constructor(private userService: UserService, private globalService: GlobalService, private router: Router) {
        super();

        this.subscriptions.push(this.userService.currentUser$.subscribe(() => this.ngOnInit()));
        this.subscriptions.push(this.userService.currentAccount$.subscribe(() => this.ngOnInit()));
        this.subscriptions.push(
            this.globalService.getMobileMainMenu().subscribe({
                next: (menu: MobileMasterMenu) => {
                    this.masterMenu = menu;
                    this.addUserInfo();
                },
                error: (error: any) => {
                    this.handleError(error);
                },
            })
        );
    }

    ngOnInit(): void {
        this.languageCode = this.globalService.getLanguageCode();
    }

    signoutUser(): void {
        this.userService.signOutUser();
        this.router.navigate([this.languageCode, 'page', 'home']);
    }

    expandMainItemPanel(event: any): void {
        event.stopPropagation();

        if (!this.isExpansionIndicator(event.target)) {
            // VERY CLUMSY - NEED SOMETHING BETTER IF POSSIBLE
            const panelId: string = event.srcElement.parentElement.parentElement.parentElement.attributes['panelid'].value;
            this.openPanel(panelId);
        }
    }

    openPanel(panelId: string): void {
        this.getPanel(panelId).toggle();
    }

    isPanelOpen(panelId: string): boolean {
        const panel: MatExpansionPanel = this.getPanel(panelId);
        if (panel) {
            return panel.expanded;
        }
        return false;
    }

    getPanel(panelId: string): MatExpansionPanel {
        let menuPanel: MatExpansionPanel;
        if (panelId && panelId !== '') {
            const menu: string = panelId.substring(0, 4);
            if (menu === 'main' && this.mainItemExpansionPanels) {
                const idx: number = +panelId.substring(4);
                menuPanel = this.mainItemExpansionPanels.toArray()[idx];
            } else if (menu === 'lang') {
                menuPanel = this.languagesPanel;
            }
        }

        return menuPanel;
    }

    expandLanguagesPanel(event: Event): void {
        event.stopPropagation();

        if (!this.isExpansionIndicator(event.target)) {
            this.languagesPanel.toggle();
        }
    }

    changeLanguage(language: MobileMenuItem): void {
        if (language.Target !== this.languageCode) {
            this.globalService.setLanguage(language.Target);
            this.languageCode = language.Target;
        }
    }

    private addUserInfo(): void {
        if (this.masterMenu.ToolbarItems.length === 0) {
            this.masterMenu.ToolbarItems[0] = new MobileMenuItem();
        }
        this.masterMenu.ToolbarItems[0].SubMenu = [];

        const user: ValidatedUser = this.userService.getCurrentUser();

        if (user) {
            const nameItem: MobileMenuItem = new MobileMenuItem();
            nameItem.Title = user.Name;
            this.masterMenu.ToolbarItems[0].SubMenu.push(nameItem);

            const account: CustomerAccount = this.userService.getCustomerAccount();
            if (account) {
                const accountItem: MobileMenuItem = new MobileMenuItem();
                accountItem.Title = account.Name;
                this.masterMenu.ToolbarItems[0].SubMenu.push(accountItem);

                const locationItem: MobileMenuItem = new MobileMenuItem();
                locationItem.Title = account.Location;
                this.masterMenu.ToolbarItems[0].SubMenu.push(locationItem);
            }
        }
    }

    private isExpansionIndicator(target): boolean {
        const expansionIndicatorClass: string = 'mat-expansion-indicator';

        return target.classList && target.classList.contains(expansionIndicatorClass);
    }
}
